module.exports = __webpack_public_path__ + "img/center-banner.aa32c5ef.png";